module.exports = __webpack_public_path__ + "admin/img/member_avatar_male.24657e00.png";